
<script>

///Ultima alteração: 10/06/2020
///Alterado por: Allinne

    import { afterUpdate }  from 'svelte';
    import ShareItem        from './Share__Item.svelte';

    afterUpdate(() => {
        try{
            jQuery('.share').popover({
                html: true,
                placement: 'top',
                content: jQuery(".share-content").html(),
            });
        }catch(ex) { }
    });    
</script>

<a class="share" href="javascript:void(0);" data-toggle="popover">
    <i class="icon-transform color-white fas fa-share-alt"></i>
</a>

<div class="share-content" style="display: none;">
    <div class="share-menu">
        <slot>
            <ShareItem type="Twitter" />
            <ShareItem type="Facebook" />
            <ShareItem type="WhatsApp" />
        </slot>
    </div>
</div>

<style type="text/sass">
.share-menu 
	margin: 0

</style>